import React from 'react';

import DataContainer from 'Components/UI/DataContainer';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import Layout from './Layout';

const LayoutContainer = () => {
  const { relationshipCollection, isInitializing } = useIncludedRelationshipContext();

  return (
    <DataContainer
      loading={isInitializing}
      component={Layout}
      componentProps={{
        effectCollection: relationshipCollection,
      }}
    />
  );
};

export default LayoutContainer;
